import React from 'react';
import styles from './AuditHeader.module.css';

const AuditHeader = ({ audit, onRefresh, isRefreshing }) => {
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  const getStatusBadge = () => {
    const statusMap = {
      'INCOMPLETE': { label: 'Incomplete', className: styles.statusIncomplete },
      'IN_PROGRESS': { label: 'In Progress', className: styles.statusInProgress },
      'COMPLETED': { label: 'Completed', className: styles.statusCompleted },
    };
    
    const status = statusMap[audit.status] || statusMap['INCOMPLETE'];
    
    return (
      <span className={`${styles.badge} ${status.className}`}>
        {status.label}
      </span>
    );
  };

  return (
    <div className={styles.header}>
      <div className={styles.titleSection}>
        <h1 className={styles.title}>
          Night Audit - {formatDate(audit.auditDate)}
        </h1>
        {getStatusBadge()}
        {audit.isCatchupMode && (
          <span className={`${styles.badge} ${styles.catchupBadge}`}>
            Catch-up Mode
          </span>
        )}
      </div>
      
      <div className={styles.actions}>
        <button 
          className={styles.refreshButton}
          onClick={onRefresh}
          disabled={isRefreshing}
        >
          {isRefreshing ? 'Refreshing...' : 'Refresh'}
        </button>
      </div>
    </div>
  );
};

export default AuditHeader;
